import React from "react";
import AnimatedNumber from "animated-number-react";

function Number(props) {
  return <AnimatedNumber formatValue={(v) => v.toFixed(props.fixed || 0)} duration={500} {...props}/>
}

export {
  Number
}
